import React from 'react';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';
import {
  ContainerOutlined,
  CloseSquareOutlined,
  SwapOutlined,
  FilePdfOutlined,
  FieldTimeOutlined,
  CreditCardOutlined,
} from '@ant-design/icons';
import { IconButton } from '../../../../common/controls/Controls';

export default function ApplicationTableSettings({
  event,
  onSubmitClick,
  onCancelClick,
  onChangeStateClick,
  onPdfClick,
  onTimelineClick,
  onArchiveClick,
  canSubmit,
  canCancel,
  canChangeState,
  canPdf,
  canTimeline,
  canArchive,
  isAdmin,
  isArchived,
  // new "request" callbacks — parent will show modals
  onRequestSubmit,
  onRequestCancel,
  onRequestChangeState,
  onRequestArchive,
  isPdfLoading,
}) {
  const { t } = useTranslation();
  const menuItems = [
    { key: 'Rozpracovaná', label: t('Rozpracovaná') },
    { key: 'Odoslaná', label: t('Odoslaná') },
    { key: 'Zrušená', label: t('Zrušená') },
    { key: 'Akceptovaná', label: t('Akceptovaná') },
    { key: 'Zamietnutá', label: t('Zamietnutá') },
  ];

  const handleMenuClick = ({ key, domEvent }) => {
    domEvent.stopPropagation();

    if (onRequestChangeState) {
      onRequestChangeState(event, key);
    } else if (onChangeStateClick) {
      onChangeStateClick(event, key);
    }
  };

  const showSubmit =
    canSubmit &&
    onSubmitClick &&
    !isAdmin &&
    event?.applicationStatus === 'Rozpracovaná';

  const showCancel =
    canCancel &&
    onCancelClick &&
    !isAdmin &&
    event?.applicationStatus !== 'Zrušená' &&
    event?.applicationStatus !== 'Zamietnutá';

  return (
    <>
      {showSubmit ? (
        <IconButton
          icon={<ContainerOutlined />}
          tooltip={t('Odoslať')}
          onClick={(e) => {
            e.stopPropagation();
            if (onRequestSubmit) return onRequestSubmit(event);
            return onSubmitClick && onSubmitClick(event);
          }}
        />
      ) : null}

      {showCancel ? (
        <IconButton
          icon={<CloseSquareOutlined />}
          tooltip={t('Zrušiť')}
          onClick={(e) => {
            e.stopPropagation();
            if (onRequestCancel) return onRequestCancel(event);
            return onCancelClick && onCancelClick(event);
          }}
        />
      ) : null}

      {onRequestChangeState && onChangeStateClick && canChangeState ? (
        <Dropdown
          placement="bottom"
          trigger={['click']}
          menu={{
            items: menuItems,
            onClick: handleMenuClick,
          }}
        >
          <IconButton
            icon={<SwapOutlined />}
            tooltip={t('Zmeniť stav prihlášky')}
            onClick={(e) => {
              e.stopPropagation(); /* dropdown opens */
            }}
          />
        </Dropdown>
      ) : null}

      {onPdfClick && canPdf ? (
        <IconButton
          icon={<FilePdfOutlined />}
          tooltip={t('Stiahnuť PDF súbor')}
          loading={isPdfLoading}
          onClick={(e) => {
            e.stopPropagation();
            onPdfClick(event);
          }}
        />
      ) : null}

      {onTimelineClick && canTimeline ? (
        <IconButton
            icon={<FieldTimeOutlined />}
            tooltip={t('História stavov')}
            onClick={(e) => {
              e.stopPropagation();
              onTimelineClick(event);
            }}
        />
      ) : null}

      {onArchiveClick && canArchive ? (
        <IconButton
          icon={<CreditCardOutlined />}
          tooltip={isArchived ? t('Obnoviť prihlášku') : t('Archivovať prihlášku')}
          onClick={(e) => {
            e.stopPropagation();
            if (onRequestArchive) {
              onRequestArchive(event);
              return;
            }

            onArchiveClick(event);
          }}
        />
      ) : null}
    </>
  );
}
